import { cn } from '@repo/ui/lib/utils'
import { LoaderCircleIcon } from 'lucide-react'
import { FunctionComponent } from 'react'

interface Props {
  loading: boolean
  className?: string
}

const Spinner: FunctionComponent<Props> = ({ className, loading }) => {
  if (!loading) {
    return null
  }

  return <LoaderCircleIcon className={cn('size-4 animate-spin text-current', className)} role='status' aria-live='polite' aria-busy='true' />
}

export { Spinner }
